import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';

import { TLocalesKeys as K } from '../../../../types';
import { ITicketItem } from '../../../common/messageCreators';
import { SelectorItem } from '../Selectors';
import { Time } from '../Time';
import { TimeAgo } from '../TimeAgo';
import { getStatusKey, stopPropagation, toLocaleDateString } from './util';

type TicketListItemProps = {
  item: ITicketItem;
  onClick: (data: ITicketItem, position: number) => void;
  position: number;
  hasFocus: boolean;
};

export const TicketListItem: FC<TicketListItemProps> = ({ item, onClick, position, hasFocus }) => {
  const { t } = useTranslation();
  const linkLabel = t<K>('ticket_link_label');

  const date = toLocaleDateString(item.creationDate);
  const status = t<K>(getStatusKey(item.status));

  const clickHandler = useCallback(() => onClick(item, position), [item, onClick, position]);

  return (
    <SelectorItem key={item.id} onClick={clickHandler} hasFocus={hasFocus}>
      <Box align="space-between">
        <Box direction="vertical" gap="SP1">
          <Text>{item.label}</Text>
          <Box direction="vertical">
            <Text size="small" secondary light>{`ID ${item.ticketNumber}`}</Text>
            <Text size="small" secondary light>
              {`${status} `}
              <TimeAgo timestamp={item.creationDate} />
              <Time date={item.creationDate}>{date}</Time>
            </Text>
          </Box>
        </Box>
        <Box verticalAlign="bottom">
          <TextButton
            size="small"
            as="a"
            href={item.link}
            target="_blank"
            onClick={stopPropagation}
            dataHook="link"
          >
            {linkLabel}
          </TextButton>
        </Box>
      </Box>
    </SelectorItem>
  );
};
